<template>
  <div class="videointerview-new-group">
    <div class="title">{{ $tr('vacancy.videoInterview.group.new') }}</div>
    <div class="form" :disabled="loading">
      <vinput
        type="text"
        v-model="new_group"
        class="form__input vcv-input"
        :placeholder="$tr('vacancy.videointerview.video.new_group')"/>
      <vbutton
        class="button"
        label="actions.add"
        :disabled="!new_group.length"
        @click="add"/>
    </div>
  </div>
</template>
<script>
  import {createNamespacedHelpers} from 'vuex';

  const {mapActions} = createNamespacedHelpers('vacancy_new/video_interview_groups');

  export default {
    name: "vacancy-videointerview-new-group",
    data () {
      return {
        new_group: '',
        loading: false,
      }
    },
    methods: {
      ...mapActions(['save_new_group']),
      add () {
        this.loading = true;
        this.save_new_group(this.new_group)
          .then(r => {
            this.new_group = '';
            this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text'));
          })
          .catch(e => {
            this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text'));
          })
          .then(() => {
            this.loading = false;
          })
      }
    }
  }
</script>
<style lang="scss" scoped>
.videointerview-new-group {
  .title {
    margin: 5px 0;
    font-weight: 700;
  }
  .form {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .form__input {
      flex-grow: 1;
      max-width: 300px;
      margin-right: 10px;
    }
  }
}
</style>